import { useEffect, useState } from 'react';
import {
  Paper, Table, TableHead, TableRow, TableCell, TableBody, Typography, Button, Stack, Chip, Box, Pagination,
} from '@mui/material';
import DashboardLayout from '../components/DashboardLayout';
import { navForRole } from '../components/officerNav';
import api from '../services/api';
import { useAuth } from '../context/AuthContext';

const PAGE_SIZE = 50;

export default function AuditLogs() {
  const { user } = useAuth();
  const [logs, setLogs] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);

  const load = async (toPage = page) => {
    const { data } = await api.get('/audit-logs', { params: { page: toPage, pageSize: PAGE_SIZE } });
    setLogs(data.data);
    setTotal(data.meta?.total || 0);
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { load(1); }, []);

  const exportCsv = async () => {
    // Stream the CSV with auth header, then trigger a download.
    const res = await api.get('/audit-logs/export.csv', { responseType: 'blob' });
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const a = document.createElement('a');
    a.href = url; a.download = 'audit-logs.csv'; a.click();
    window.URL.revokeObjectURL(url);
  };

  const pageCount = Math.max(1, Math.ceil(total / PAGE_SIZE));

  return (
    <DashboardLayout nav={navForRole(user?.role)} welcomeName={user?.fullName} title="Audit Logs">
      <Stack direction="row" justifyContent="flex-end" sx={{ mb: 2 }}>
        <Button variant="outlined" onClick={exportCsv}>Export CSV</Button>
      </Stack>

      <Paper>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Timestamp</TableCell><TableCell>User</TableCell><TableCell>Action</TableCell>
              <TableCell>Entity</TableCell><TableCell>IP</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {logs.map((l) => (
              <TableRow key={l.id}>
                <TableCell>{new Date(l.createdAt).toLocaleString('en-GB')}</TableCell>
                <TableCell>{l.user?.email || '—'}</TableCell>
                <TableCell><Chip size="small" label={l.action} variant="outlined" /></TableCell>
                <TableCell>{l.entityType ? `${l.entityType}` : '—'}</TableCell>
                <TableCell>{l.ipAddress || '—'}</TableCell>
              </TableRow>
            ))}
            {logs.length === 0 && (
              <TableRow><TableCell colSpan={5}><Typography color="text.secondary" sx={{ py: 2, textAlign: 'center' }}>No audit entries yet.</Typography></TableCell></TableRow>
            )}
          </TableBody>
        </Table>
      </Paper>

      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
        <Pagination count={pageCount} page={page} onChange={(_, p) => { setPage(p); load(p); }} color="primary" />
      </Box>
    </DashboardLayout>
  );
}
